// extracted by mini-css-extract-plugin
export default {"results-message":"OPFMa1","results-message__title":"Q5zJ3l","results-message__description":"rn4vdj","results-message__illustration":"nRADh3","results-message__image":"AJmoEE"};